import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ProfileContent from "../../../components/comment/profile/profileContent";
import BookingContent from "../../../components/comment/booking/bookingContent";

const bookingContent = () => {
  return (
    <div className="main-booking-content pt-3 pb-5">
      <Container className="main-content ">
        <Row className="main-content">
          <Col lg={3} className="content-left">
            <ProfileContent />
          </Col>

          <Col lg={9} className="main-content-right booking-content-wrap  ">
            <BookingContent />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default bookingContent;
